import {
  FORGET_PASSWORD,
  FORGET_PASSWORD_SUCCESS,
  FORGET_PASSWORD_ERROR,

  VERIFY_FORGET_PASSWORD,
  VERIFY_FORGET_PASSWORD_SUCCESS,
  VERIFY_FORGET_PASSWORD_FAIL,

  RESEND_FORGET_PASSWORD_CODE,
  RESEND_FORGET_PASSWORD_CODE_SUCCESS,
  RESEND_FORGET_PASSWORD_CODE_FAIL,


} from "./actionTypes"

const initialState = {
  forgetSuccessMsg: null,
  forgetError: null,

  // verify
  verifyForgetPasswordLoading: false,
  verifyForgetPasswordError: null,

  invitationData: null, 

  // État spécifique pour le renvoi du code (peut être combiné ou séparé)
    resendLoading: false,
    resendError: null,
}

const forgetPassword = (state = initialState, action) => {
  switch (action.type) {

    case FORGET_PASSWORD:
      state = {
        ...state,
        forgetSuccessMsg: null,
        forgetError: null,
      }
      break
    case FORGET_PASSWORD_SUCCESS:
      state = {
        ...state,
        forgetSuccessMsg: action.payload,
      }
      break
    case FORGET_PASSWORD_ERROR:
      state = { ...state, forgetError: action.payload }
      break
    
      // VERIFY
    case VERIFY_FORGET_PASSWORD:
      return {
          ...state,
          verifyForgetPasswordLoading: true,
          verifyForgetPasswordError: null, 
      };

    case VERIFY_FORGET_PASSWORD_SUCCESS:
      return {
          ...state,
          verifyForgetPasswordLoading: false,
          verifyForgetPasswordError: null,
          //invitationData: action.payload, 
          
      };

    case VERIFY_FORGET_PASSWORD_FAIL:
      return {
          ...state,
          verifyForgetPasswordLoading: false,
          verifyForgetPasswordError: action.payload, 
      };


      // RESEND FORGET PASSWORD CODE
              
      case RESEND_FORGET_PASSWORD_CODE:
          return {
              ...state,
              resendLoading: true,
              resendError: null,
          };

      case RESEND_FORGET_PASSWORD_CODE_SUCCESS:
          // Le succès ne modifie que le statut de chargement. 
          // La notification est gérée par Saga (Toastify).
          return {
              ...state,
              resendLoading: false,
              resendError: null,
          };

      case RESEND_FORGET_PASSWORD_CODE_FAIL:
          return {
              ...state,
              resendLoading: false,
              resendError: action.payload, // Stocke l'erreur de renvoi
          };

    default:
      state = { ...state }
      break

      
  }
  return state
}

export default forgetPassword
